import type { IUseGetSocialOfferPrescriptionFilledResponse } from "@api";
import { Tooltip } from "@mui/material";
import { Avatar } from "@mui/material";
import { Stack } from "@mui/material";
import { Typography } from "@mui/material";
import { formatPhoneNumber } from "@root/utils/phoneLib";
import { themeBBJ } from "@styleguide";
import { UserChipStyled, classes } from "../styles";

interface IAuthorChip {
  author: IUseGetSocialOfferPrescriptionFilledResponse["author"];
}

export const AuthorChip = ({ author }: IAuthorChip) => {
  return (
    <UserChipStyled className={classes.avatarGroup} max={1}>
      <Tooltip
        title={
          <Stack
            sx={(theme) => ({
              padding: theme.spacing(1),
              color: "black.main",
              textWrap: "nowrap",
            })}
          >
            <Typography variant="body1SemiBold" sx={{ display: "flex", flexDirection: "row" }}>
              Auteur de la prescription :&nbsp;
              <Typography variant="body1">
                {author.firstName} {author.lastName}
              </Typography>
            </Typography>
            {author.phone && (
              <Typography variant="body1SemiBold" sx={{ display: "flex", flexDirection: "row" }}>
                Téléphone :&nbsp;
                <Typography variant="body1">{formatPhoneNumber(author.phone)}</Typography>
              </Typography>
            )}
            {author.email && (
              <Typography variant="body1SemiBold" sx={{ display: "flex", flexDirection: "row" }}>
                Email :&nbsp;
                <Typography variant="body1">{author.email}</Typography>
              </Typography>
            )}
          </Stack>
        }
        slotProps={{
          popper: {
            sx: {
              "& .MuiTooltip-tooltip": {
                background: themeBBJ.palette.background.paper,
                maxWidth: "500px",
                opacity: "1 !important",
              },
            },
          }
        }}
      >
        <Avatar sizes="small">
          {author.firstName?.[0]?.toUpperCase()}
          {author.lastName?.[0]?.toUpperCase()}
        </Avatar>
      </Tooltip>
    </UserChipStyled>
  );
};
